import axios from 'axios';
import token from './authToken';

// const lambUrl = 'https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp';
const lambUrl = 'https://wfsajq7upd.execute-api.ap-south-1.amazonaws.com/prod/neodisha-fashion-webapp';

export const GetCaptureProgress = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_capture_progress`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};

export const dates = async () => {
  try {
    const res = await axios.get(`${lambUrl}/store/calender`);
    return res;
  } catch (error) {
    console.log('Error Calling Event dates API: ', error);
  }
};

export const GetBrandDonutData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/doughtnut/brand_wise_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetBrandDonutData API: ', error);
  }
};

export const GetFullnessKpi = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_card_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('fullness res', res);
    return res;
  } catch (error) {
    console.log('Error Calling GetFullnessKpi API: ', error);
  }
};

export const GetAnomaliesKpi = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/card_anomalies`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('anomaliesData', res);
    return res;
  } catch (error) {
    console.log('Error Calling GetAnomaliesKpi API: ', error);
  }
};

export const GetAnomaliesBarChartData = async (data) => {
  try {
    const res = await axios.post(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/dashboard/anomalies_barchart`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res;
  } catch (error) {
    console.log('Error Calling GetAnomaliesKpi API: ', error);
  }
};

// API FOR THE LAYOUT OF THE STORE
export const GetStoreLayout = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store/analysis`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('api response', res);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};
// API FOR THE LAYOUT OF THE STORE
export const GetImagesFromSignedUrl = async (data) => {
  try {
    const res = await axios.post(`https://wfsajq7upd.execute-api.ap-south-1.amazonaws.com/prod/neodisha-fashion-app/signed_image`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

export const getUsers = async () => {
  try {
    const res = await axios.post(`http://localhost:7072/api/sentinel/getAllUsers`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team API :', error);
  }
};

export const getOneUser = async (id) => {
  try {
    const res = await axios.get(`${lambUrl}/team/get_one_user?userID=${id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const deleteUser = async (id) => {
  try {
    const res = await axios.post(`http://localhost:7072/api/sentinel/delete/${id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const updateUser = async (id, user) => {
  try {
    const res = await axios.post(`http://localhost:7072/api/sentinel/update/${id}`, user, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const createUser = async (user) => {
  try {
    const res = await axios.post(`http://localhost:7072/api/sentinel/users`, user, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const GetVerifiedUsers = async (phoneNumber) => {
  try {
    const res = await axios.get(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-app/user/auth_user_cred?numbers=${phoneNumber}`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );
    // console.log(res.data);
    return res;
  } catch (error) {
    console.log('Error Calling users API: ', error);
  }
};

export const GetVMCompliance = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/vmc_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetVMCompliance API: ', error);
  }
};

export const GetVMComplianceForOneWeek = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/timeseries_vmc`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('result', res);
    return res;
  } catch (error) {
    console.log('Error calling vm compliance for a week api', error);
  }
};

export const GetFullnessForOneWeek = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/timeseries_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling fullness for a week api', error);
  }
};

export const GetAnomalyDetails = async (data) => {
  try {
    const res = await axios.get(`${lambUrl}/store/get_analysis_data?analysisID=${data}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetAnomalyDetails API: ', error);
  }
};

export const GetAnomaliesForOneWeek = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/timeseries_anomalies`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling anomalies for a week api', error);
  }
};

export const checkId = async (user_id) => {
  try {
    const res = await axios.get(`${lambUrl}/team/check_users?user_id=${user_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error');
    throw error;
  }
};

export const allStoresId = async () => {
  try {
    const res = await axios.get(
      `https://wfsajq7upd.execute-api.ap-south-1.amazonaws.com/prod/neodisha-fashion-webapp/store/get_all_store`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res.data;
  } catch (error) {
    console.log('Error occured');
    throw error;
  }
};

export const GetBarChartData = async (data) => {
  try {
    const res = await axios.post(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/dashboard/bay_wise_fullness`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    console.log('bar chart data', res);
    return res;
  } catch (error) {
    console.log('Error calling bar chart api', error);
  }
};

export const GetVMscoreBar = async (data) => {
  try {
    const res = await axios.post(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/dashboard/vmc-barchart`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    console.log('vmc data', res);
    return res;
  } catch (error) {
    console.log('Error calling bar chart api', error);
  }
};

export const GetStoreWiseInfo = async (date, store_id) => {
  try {
    const res = await axios.get(`${lambUrl}/store/stores_wise_config?date=${date}&store_id=${store_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling store wise info', error);
  }
};
export const GetBayWiseDetails = async (date) => {
  try {
    const res = await axios.get(`${lambUrl}/store/bay_wise_config?date=${date}&store_id=6582be9ac5ed94d792a563b8`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bay wise details API: ', error);
  }
};

export const GetShelfWiseDetails = async (date, bay_id) => {
  try {
    const res = await axios.get(`${lambUrl}/store/shelf_wise_config?date=${date}&bay_id=${bay_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling shelf-wise details', error);
  }
};

export const GetPartsWiseDetails = async (date, shelf_id) => {
  try {
    const res = await axios.get(`${lambUrl}/store/parts_wise_config?date=${date}&shelf_id=${shelf_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling parts-wise details', error);
  }
};

export const LoginAPI = async (number, email, password) => {
  try {
    const data = {
      number: number,
      email: email,
      hashed_password: password
    };
    const res = await axios.post(`https://db.neophyte.live/sentinel-api/api/sentinel/login`, data, {
      headers: {
        Accept: 'application/json'
      }
    });
    console.log('response login', res);
    return res;
  } catch (error) {
    console.log('Error calling login api', error);
  }
};

export const getAvailability = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/get_hourly_counts', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/get_hourly_counts', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /availability:', res);
    return res;
  } catch (error) {
    console.log('Error calling /availability API', error);
    throw error;
  }
};

// export const getAvailability = async (requestData) => {
//   try {
//     const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/get_hourly_counts', requestData, {
//       headers: { Accept: 'application/json' }
//     });
//     console.log('Response from /availability:', res);
//     return res;
//   } catch (error) {
//     console.log('Error calling /availability API', error);
//     throw error;
//   }
// };

export const getCustomerEmployeeRatio = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/customer_employee_ratio', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/customer_employee_ratio', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /customerEmployeeRatio:', res);
    return res;
  } catch (error) {
    console.log('Error calling /customerEmployeeRatio API', error);
    throw error;
  }
};

export const getGenderAgeDistribution = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/gender_age_distribution', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/gender_age_distribution', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /gender-age-distribution:', res);
    return res;
  } catch (error) {
    console.log('Error calling /gender-age-distribution API', error);
    throw error;
  }
};

export const getUniqueWalkinWalkout = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/unique_walkin_walkout', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/unique_walkin_walkout', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /unique_walkin_walkout:', res);
    return res;
  } catch (error) {
    console.log('Error calling /unique_walkin_walkout API', error);
    throw error;
  }
};

// API to get customer dwell time data
export const getCustomerDwellTime = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/customer_dwell_time', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/customer_dwell_time', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /customer_dwell_time:', res);
    return res;
  } catch (error) {
    console.log('Error calling /customer_dwell_time API', error);
    throw error;
  }
};

// API to get zonal staff presence data
export const getZonalStaffPresence = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/zonal_staff_presence', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/zonal_staff_presence', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /zonal_staff_presence:', res);
    return res;
  } catch (error) {
    console.log('Error calling /zonal_staff_presence API', error);
    throw error;
  }
};

export const getEmployeeAvailability = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/get_employee_availability', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/get_employee_availability', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /employee_availability:', res);
    return res;
  } catch (error) {
    console.log('Error calling /employee_availability API', error);
    throw error;
  }
};

export const getLightOnOffData = async (requestData) => {
  try {
    const res = await axios.post('https://disha-pocket.neophyte.live/trends-api/api/sentinel/light_on_off', requestData, {
      // const res = await axios.post('http://localhost:7072/api/sentinel/light_on_off', requestData, {
      headers: { Accept: 'application/json' }
    });
    console.log('Response from /light_on_off:', res);
    return res;
  } catch (error) {
    console.log('Error calling /light_on_off API', error);
    throw error;
  }
};

export const STORES_API = 'https://disha-pocket.neophyte.live/trends-api/api/sentinel/getStores';


// export const getUsers = async (data) => {
//   try {
//     const res = await axios.post(
//       // `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/team/getalluser`,
//       `${lambUrl}/team/getalluser`,
//       data,
//       {
//         headers: {
//           Accept: 'application/json',
//           Authorization: await token()
//         }
//       }
//     );
//     // console.log("api image response", res);
//     return res;
//   } catch (error) {
//     console.log('Error while calling team API :', error);
//   }
// };
